import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiUsr from 'apiSaga/apiUser';
import createRequestSaga from 'apiSaga/createRequestSaga';

/******************************* EDI 서비스 가입 **************************************************** */

const INIT_USER_RESP = 'usr/INIT_USER_RESP';
const INIT_INIT_DATA_RESP = 'usr/INIT_INIT_DATA_RESP';
const INIT_BANK_ACCOUNT_LIST_RESP = 'usr/INIT_BANK_ACCOUNT_LIST_RESP';
const INIT_CHECK_CUSTCD_RESP = 'usr/INIT_CHECK_CUSTCD_RESP';
const INIT_DUP_CHECK_USERID_RESP = 'usr/INIT_DUP_CHECK_USERID_RESP';
const INIT_JOIN_USERID_RESP = 'usr/INIT_JOIN_USERID_RESP';
const INIT_SEND_SMS_RESP = 'usr/INIT_SEND_SMS_RESP';
const INIT_CHECK_NOCERT_RESP = 'usr/INIT_CHECK_NOCERT_RESP';
const INIT_POLICY_RESP = 'usr/INIT_POLICY_RESP';
const INIT_COMPL_USER_INFO_RESP = 'usr/INIT_COMPL_USER_INFO_RESP';
const INIT_SEND_CONFIRM_MSG_RESP = 'usr/INIT_SEND_CONFIRM_MSG_RESP';
const INIT_PUT_CONFIRM_CHK_RESP = 'usr/INIT_PUT_CONFIRM_CHK_RESP';

// 1. 서비스 가입 납부방식 조회
const GET_INIT_DATA = 'usr/GET_INIT_DATA';
const GET_INIT_DATA_SUCCESS = 'usr/GET_INIT_DATA_SUCCESS';
const GET_INIT_DATA_FAILURE = 'usr/GET_INIT_DATA_FAILURE';
// 2. 서비스가입 은행계좌 조회
const GET_BANK_ACCOUNT_LIST = 'usr/GET_BANK_ACCOUNT_LIST';
const GET_BANK_ACCOUNT_LIST_SUCCESS = 'usr/GET_BANK_ACCOUNT_LIST_SUCCESS';
const GET_BANK_ACCOUNT_LIST_FAILURE = 'usr/GET_BANK_ACCOUNT_LIST_FAILURE';
// 3. 서비스가입 고객코드 체크
const GET_CHECK_CUSTCD = 'usr/GET_CHECK_CUSTCD';
const GET_CHECK_CUSTCD_SUCCESS = 'usr/GET_CHECK_CUSTCD_SUCCESS';
const GET_CHECK_CUSTCD_FAILURE = 'usr/GET_CHECK_CUSTCD_FAILURE';
// 4. 서비스가입 아이디 중복 체크
const GET_DUP_CHECK_USERID = 'usr/GET_DUP_CHECK_USERID';
const GET_DUP_CHECK_USERID_SUCCESS = 'usr/GET_DUP_CHECK_USERID_SUCCESS';
const GET_DUP_CHECK_USERID_FAILURE = 'usr/GET_DUP_CHECK_USERID_FAILURE';
// 5. 서비스가입 가입하기
const PUT_JOIN_USERID = 'usr/PUT_JOIN_USERID';
const PUT_JOIN_USERID_SUCCESS = 'usr/PUT_JOIN_USERID_SUCCESS';
const PUT_JOIN_USERID_FAILURE = 'usr/PUT_JOIN_USERID_FAILURE';
// 6.SMS전송
const PUT_SEND_SMS = 'usr/PUT_SEND_SMS';
const PUT_SEND_SMS_SUCCESS = 'usr/PUT_SEND_SMS_SUCCESS';
const PUT_SEND_SMS_FAILURE = 'usr/PUT_SEND_SMS_FAILURE';
// 7.SMS인증 체크
const GET_CHECK_NOCERT = 'usr/GET_CHECK_NOCERT';
const GET_CHECK_NOCERT_SUCCESS = 'usr/GET_CHECK_NOCERT_SUCCESS';
const GET_CHECK_NOCERT_FAILURE = 'usr/GET_CHECK_NOCERT_FAILURE';
// 8. 사용자 정책 조회
const GET_POLICY = 'usr/GET_POLICY';
const GET_POLICY_SUCCESS = 'usr/GET_POLICY_SUCCESS';
const GET_POLICY_FAILURE = 'usr/GET_POLICY_FAILURE';

// 9.가입성공 유저조회
const GET_COMPL_USER_INFO = 'usr/GET_COMPL_USER_INFO';
const GET_COMPL_USER_INFO_SUCCESS = 'usr/GET_COMPL_USER_INFO_SUCCESS';
const GET_COMPL_USER_INFO_FAILURE = 'usr/GET_COMPL_USER_INFO_FAILURE';
// 2차인증 메세지 전송
const SEND_CONFIRM_MSG = 'usr/SEND_CONFIRM_MSG';
const SEND_CONFIRM_MSG_SUCCESS = 'usr/SEND_CONFIRM_MSG_SUCCESS';
const SEND_CONFIRM_MSG_FAILURE = 'usr/SEND_CONFIRM_MSG_FAILURE';

// 인증번호 체크
const PUT_CONFIRM_CHK = 'usr/PUT_CONFIRM_CHK';
const PUT_CONFIRM_CHK_SUCCESS = 'usr/PUT_CONFIRM_CHK_SUCCESS';
const PUT_CONFIRM_CHK_FAILURE = 'usr/PUT_CONFIRM_CHK_FAILURE';

export const initInitDataResp = createAction(INIT_INIT_DATA_RESP);
export const initBankAccountListResp = createAction(INIT_BANK_ACCOUNT_LIST_RESP);
export const initCheckCustCdResp = createAction(INIT_CHECK_CUSTCD_RESP);
export const initDupCheckUserIdResp = createAction(INIT_DUP_CHECK_USERID_RESP);
export const initJoinUserIdResp = createAction(INIT_JOIN_USERID_RESP);
export const initSendSMSResp = createAction(INIT_SEND_SMS_RESP);
export const initCheckNoCertResp = createAction(INIT_CHECK_NOCERT_RESP);
export const initPolicyResp = createAction(INIT_POLICY_RESP);
export const initComplUserInfoResp = createAction(INIT_COMPL_USER_INFO_RESP);
export const initSendConfirmMsgResp = createAction(INIT_SEND_CONFIRM_MSG_RESP);
export const initPutConfirmChkResp = createAction(INIT_PUT_CONFIRM_CHK_RESP);

// 1. 공통코드조회
export const getInitData = createAction(GET_INIT_DATA, (initData) => initData);
// 2. 서비스가입신청 은행계좌조회
export const getBankAccountList = createAction(GET_BANK_ACCOUNT_LIST, (sysGroupCode) => sysGroupCode);
// 3. 서비스가입신청 고객코드 체크
export const getCheckCustCd = createAction(GET_CHECK_CUSTCD, (custInfo) => custInfo);
// 4. 서비스가입신청 아이디중복 체크
export const getDupCheckUserId = createAction(GET_DUP_CHECK_USERID, (userInfo) => userInfo);
// 5. 서비스가입신청 회원가입
export const putJoinUserId = createAction(PUT_JOIN_USERID, (userInfo) => userInfo);
// 6. SMS전송
export const putSendSms = createAction(PUT_SEND_SMS, (userInfo) => userInfo);
// 7. SMS인증 체크
export const getCheckNoCert = createAction(GET_CHECK_NOCERT, (userInfo) => userInfo);
// 7. 사용자 정책 조회
export const getPolicy = createAction(GET_POLICY, (agreeCode) => agreeCode);

export const getComplUserInfo = createAction(GET_COMPL_USER_INFO, (userInfo) => userInfo);
// 2차인증 메세지 전송
export const sendConfirmMsg = createAction(SEND_CONFIRM_MSG, (userInfo) => userInfo);
// 2차인증 체크
export const putConfirmChk = createAction(PUT_CONFIRM_CHK, (userInfo) => userInfo);

const getInitDataSaga = createRequestSaga(GET_INIT_DATA, apiUsr.getInitData);
const getBankAccountListSaga = createRequestSaga(GET_BANK_ACCOUNT_LIST, apiUsr.getBankAccountList);
const getCheckCustCdSaga = createRequestSaga(GET_CHECK_CUSTCD, apiUsr.getCheckCustCd);
const getDupCheckUserIdSaga = createRequestSaga(GET_DUP_CHECK_USERID, apiUsr.getDupCheckUserId);
const putJoinUserIdSaga = createRequestSaga(PUT_JOIN_USERID, apiUsr.putJoinUserId);
const putSendSMSSaga = createRequestSaga(PUT_SEND_SMS, apiUsr.putSendSMS);
const getCheckNoCertSaga = createRequestSaga(GET_CHECK_NOCERT, apiUsr.getCheckNoCert);
const getPolicySaga = createRequestSaga(GET_POLICY, apiUsr.getPolicy);
const getComplUserInfoSaga = createRequestSaga(GET_COMPL_USER_INFO, apiUsr.getComplUserInfo);
const sendConfirmMsgSaga = createRequestSaga(SEND_CONFIRM_MSG, apiUsr.sendConfirmMsg);
const putConfirmChkSaga = createRequestSaga(PUT_CONFIRM_CHK, apiUsr.putConfirmChk);

/******************************* LOGIN **************************************************** */

const INIT_LOGIN_RESP = 'usr/INIT_LOGIN_RESP';
const INIT_GET_NEW_POLICY_RESP = 'usr/INIT_GET_NEW_POLICY_RESP';
const INIT_SET_NEW_POLICY_RESP = 'usr/INIT_SET_NEW_POLICY_RESP';
const INIT_SEND_TEMP_PWD_RESP = 'usr/INIT_SEND_TEMP_PWD_RESP';
const INIT_SET_NEW_PWD_RESP = 'usr/INIT_SET_NEW_PWD_RESP';
const INIT_SET_NEW_PWD_BY_PERIOD_RESP = 'usr/INIT_SET_NEW_PWD_BY_PERIOD_RESP';
const INIT_DELAY_PWD_DT_RESP = 'usr/INIT_DELAY_PWD_DT_RESP';
const INIT_LOGOUT_RESP = 'usr/INIT_LOGOUT_RESP';
const INIT_LOGIN_LOG_RESP = 'usr/INIT_LOGIN_LOG_RESP';

// 1. 로그인
const SET_LOGIN = 'usr/SET_LOGIN';
const SET_LOGIN_SUCCESS = 'usr/SET_LOGIN_SUCCESS';
const SET_LOGIN_FAILURE = 'usr/SET_LOGIN_FAILURE';
// 새로운정책 조회
const GET_NEW_POLICY = 'usr/GET_NEW_POLICY';
const GET_NEW_POLICY_SUCCESS = 'usr/GET_NEW_POLICY_SUCCESS';
const GET_NEW_POLICY_FAILURE = 'usr/GET_NEW_POLICY_FAILURE';
// 새로운정책 동의
const SET_NEW_POLICY = 'usr/SET_NEW_POLICY';
const SET_NEW_POLICY_SUCCESS = 'usr/SET_NEW_POLICY_SUCCESS';
const SET_NEW_POLICY_FAILURE = 'usr/SET_NEW_POLICY_FAILURE';
//임시비밀번호 발송
const SEND_TEMP_PWD = 'usr/SEND_TEMP_PWD';
const SEND_TEMP_PWD_SUCCESS = 'usr/SEND_TEMP_PWD_SUCCESS';
const SEND_TEMP_PWD_FAILURE = 'usr/SEND_TEMP_PWD_FAILURE';
//새비밀번호설정
const SET_NEW_PWD = 'usr/SET_NEW_PWD';
const SET_NEW_PWD_SUCCESS = 'usr/SET_NEW_PWD_SUCCESS';
const SET_NEW_PWD_FAILURE = 'usr/SET_NEW_PWD_FAILURE';
//새비밀번호설정(변경주기)
const SET_NEW_PWD_BY_PERIOD = 'usr/SET_NEW_PWD_BY_PERIOD';
const SET_NEW_PWD_BY_PERIOD_SUCCESS = 'usr/SET_NEW_PWD_BY_PERIOD_SUCCESS';
const SET_NEW_PWD_BY_PERIOD_FAILURE = 'usr/SET_NEW_PWD_BY_PERIOD_FAILURE';
//비밀번호 주기 30일 연장
const SET_DELAY_PWD_DT = 'usr/SET_DELAY_PWD_DT';
const SET_DELAY_PWD_DT_SUCCESS = 'usr/SET_DELAY_PWD_DT_SUCCESS';
const SET_DELAY_PWD_DT_FAILURE = 'usr/SET_DELAY_PWD_DT_FAILURE';
// 로그아웃
const SET_LOGOUT = 'usr/SET_LOGOUT';
const SET_LOGOUT_SUCCESS = 'usr/SET_LOGOUT_SUCCESS';
const SET_LOGOUT_FAILURE = 'usr/SET_LOGOUT_FAILURE';
// 중복로그인 체크후 로그 저장
const SET_LOGIN_LOG = 'usr/SET_LOGIN_LOG';
const SET_LOGIN_LOG_SUCCESS = 'usr/SET_LOGIN_LOG_SUCCESS';
const SET_LOGIN_LOG_FAILURE = 'usr/SET_LOGIN_LOG_FAILURE';

export const initLoginResp = createAction(INIT_LOGIN_RESP);
export const initLogoutResp = createAction(INIT_LOGOUT_RESP);
export const initGetNewPolicyResp = createAction(INIT_GET_NEW_POLICY_RESP);
export const initSetNewPolicyResp = createAction(INIT_SET_NEW_POLICY_RESP);
export const initSendTempPwdResp = createAction(INIT_SEND_TEMP_PWD_RESP);
export const initNewPwdResp = createAction(INIT_SET_NEW_PWD_RESP);
export const initNewPwdbyPeriod = createAction(INIT_SET_NEW_PWD_BY_PERIOD_RESP);
export const initDelayPwdDtResp = createAction(INIT_DELAY_PWD_DT_RESP);
export const initLoginLogResp = createAction(INIT_LOGIN_LOG_RESP);

// 1. 로그인
export const setLogin = createAction(SET_LOGIN, (userInfo) => userInfo);
export const setLogout = createAction(SET_LOGOUT, (userInfo) => userInfo);
export const getNewPolicy = createAction(GET_NEW_POLICY, (userInfo) => userInfo);
export const setNewPolicy = createAction(SET_NEW_POLICY, (userInfo) => userInfo);
export const sendTempPwd = createAction(SEND_TEMP_PWD, (userInfo) => userInfo);
export const setNewPwd = createAction(SET_NEW_PWD, (userInfo) => userInfo);
export const setNewPwdbyPeriod = createAction(SET_NEW_PWD_BY_PERIOD, (userInfo) => userInfo);
export const setDelayPwdDt = createAction(SET_DELAY_PWD_DT, (userInfo) => userInfo);
export const setLoginLog = createAction(SET_LOGIN_LOG, (userInfo) => userInfo);

const setLoginSaga = createRequestSaga(SET_LOGIN, apiUsr.setLogin);
const setLogoutSaga = createRequestSaga(SET_LOGOUT, apiUsr.setLogout);
const getNewPolicySaga = createRequestSaga(GET_NEW_POLICY, apiUsr.getNewPolicy);
const setNewPolicySaga = createRequestSaga(SET_NEW_POLICY, apiUsr.setNewPolicy);
const sendTempPwdSaga = createRequestSaga(SEND_TEMP_PWD, apiUsr.sendTempPwd);
const setNewPwdSaga = createRequestSaga(SET_NEW_PWD, apiUsr.setNewPwd);
const setNewPwdbyPeriodSaga = createRequestSaga(SET_NEW_PWD_BY_PERIOD, apiUsr.setNewPwdbyPeriod);
const setDelayPwdDtSaga = createRequestSaga(SET_DELAY_PWD_DT, apiUsr.setDelayPwdDt);
const setLoginLogSaga = createRequestSaga(SET_LOGIN_LOG, apiUsr.setLoginLog);
/***************************************************************************************************** */
/**********************************마이페이지************************************************ */

const INIT_GET_USER_INFO_RESP = 'usr/INIT_GET_USER_INFO_RESP';
const INIT_GET_CORP_INFO_RESP = 'usr/INIT_GET_CORP_INFO_RESP';
const INIT_UPDATE_USER_INFO_RESP = 'usr/INIT_UPDATE_USER_INFO_RESP';
const INIT_UPDATE_USER_PWD_RESP = 'usr/INIT_UPDATE_USER_PWD_RESP';
const INIT_DELETE_USER_INFO_RESP = 'usr/INIT_DELETE_USER_INFO_RESP';
const INIT_UPDATE_CORP_INFO_RESP = 'usr/INIT_UPDATE_CORP_INFO_RESP';
const INIT_DELETE_CORP_INFO_RESP = 'usr/INIT_DELETE_CORP_INFO_RESP';

const INIT_GET_SVC_RPT_INFO_RESP = 'usr/INIT_GET_SVC_RPT_INFO_RESP';
const INIT_UPDATE_SVC_RPT_INFO_RESP = 'usr/INIT_UPDATE_SVC_RPT_INFO_RESP';
const INIT_GET_SVC_RPT_HIST_LIST_RESP = 'usr/INIT_GET_SVC_RPT_HIST_LIST_RESP';
const INIT_GET_SVC_RPT_HIST_INIT_DATA_RESP = 'usr/INIT_GET_SVC_RPT_HIST_INIT_DATA_RESP';
const INIT_CANCEL_SVC_RPT_INFO_RESP = 'usr/INIT_CANCEL_SVC_RPT_INFO_RESP';

// 고개정보 조회
const GET_USER_INFO = 'usr/GET_USER_INFO';
const GET_USER_INFO_SUCCESS = 'usr/GET_USER_INFO_SUCCESS';
const GET_USER_INFO_FAILURE = 'usr/GET_USER_INFO_FAILURE';

//  고객정보 수정
const UPDATE_USER_INFO = 'usr/UPDATE_USER_INFO';
const UPDATE_USER_INFO_SUCCESS = 'usr/UPDATE_USER_INFO_SUCCESS';
const UPDATE_USER_INFO_FAILURE = 'usr/UPDATE_USER_INFO_FAILURE';
//비밀번호 변경
const UPDATE_USER_PWD = 'usr/UPDATE_USER_PWD';
const UPDATE_USER_PWD_SUCCESS = 'usr/UPDATE_USER_PWD_SUCCESS';
const UPDATE_USER_PWD_FAILURE = 'usr/UPDATE_USER_PWD_FAILURE';
//  고객정보 탈퇴
const DELETE_USER_INFO = 'usr/DELETE_USER_INFO';
const DELETE_USER_INFO_SUCCESS = 'usr/DELETE_USER_INFO_SUCCESS';
const DELETE_USER_INFO_FAILURE = 'usr/DELETE_USER_INFO_FAILURE';
// 사업자정보 조회
const GET_CORP_INFO = 'usr/GET_CORP_INFO';
const GET_CORP_INFO_SUCCESS = 'usr/GET_CORP_INFO_SUCCESS';
const GET_CORP_INFO_FAILURE = 'usr/GET_CORP_INFO_FAILURE';
//  사업자정보 수정
const UPDATE_CORP_INFO = 'usr/UPDATE_CORP_INFO';
const UPDATE_CORP_INFO_SUCCESS = 'usr/UPDATE_CORP_INFO_SUCCESS';
const UPDATE_CORP_INFO_FAILURE = 'usr/UPDATE_CORP_INFO_FAILURE';
//서비스 해지
const DELETE_CORP_INFO = 'usr/DELETE_CORP_INFO';
const DELETE_CORP_INFO_SUCCESS = 'usr/DELETE_CORP_INFO_SUCCESS';
const DELETE_CORP_INFO_FAILURE = 'usr/DELETE_CORP_INFO_FAILURE';

// 서비스요금제 조회
const GET_SVC_RPT_INFO = 'usr/GET_SVC_RPT_INFO';
const GET_SVC_RPT_INFO_SUCCESS = 'usr/GET_SVC_RPT_INFO_SUCCESS';
const GET_SVC_RPT_INFO_FAILURE = 'usr/GET_SVC_RPT_INFO_FAILURE';
//  서비스요금제 수정
const UPDATE_SVC_RPT_INFO = 'usr/UPDATE_SVC_RPT_INFO';
const UPDATE_SVC_RPT_INFO_SUCCESS = 'usr/UPDATE_SVC_RPT_INFO_SUCCESS';
const UPDATE_SVC_RPT_INFO_FAILURE = 'usr/UPDATE_SVC_RPT_INFO_FAILURE';
// 서비스요금제 초기데이터
const GET_SVC_RPT_HIST_INIT_DATA = 'usr/GET_SVC_RPT_HIST_INIT_DATA';
const GET_SVC_RPT_HIST_INIT_DATA_SUCCESS = 'usr/GET_SVC_RPT_HIST_INIT_DATA_SUCCESS';
const GET_SVC_RPT_HIST_INIT_DATA_FAILURE = 'usr/GET_SVC_RPT_HIST_INIT_DATA_FAILURE';
// 서비스요금제 이력조회
const GET_SVC_RPT_HIST_LIST = 'usr/GET_SVC_RPT_HIST_LIST';
const GET_SVC_RPT_HIST_LIST_SUCCESS = 'usr/GET_SVC_RPT_HIST_LIST_SUCCESS';
const GET_SVC_RPT_HIST_LIST_FAILURE = 'usr/GET_SVC_RPT_HIST_LIST_FAILURE';
//  서비스요금제 취소
const CANCEL_SVC_RPT_INFO = 'usr/CANCEL_SVC_RPT_INFO';
const CANCEL_SVC_RPT_INFO_SUCCESS = 'usr/CANCEL_SVC_RPT_INFO_SUCCESS';
const CANCEL_SVC_RPT_INFO_FAILURE = 'usr/CANCEL_SVC_RPT_INFO_FAILURE';

export const initUserInfoResp = createAction(INIT_GET_USER_INFO_RESP);
export const initCorpInfoResp = createAction(INIT_GET_CORP_INFO_RESP);
export const initUpdateUserInfo = createAction(INIT_UPDATE_USER_INFO_RESP);
export const initUpdateUserPwd = createAction(INIT_UPDATE_USER_PWD_RESP);
export const initDeleteUserInfo = createAction(INIT_DELETE_USER_INFO_RESP);
export const initUpdateCorpInfo = createAction(INIT_UPDATE_CORP_INFO_RESP);
export const initDeleteCorpInfo = createAction(INIT_DELETE_CORP_INFO_RESP);

export const initSvcRptInfoResp = createAction(INIT_GET_SVC_RPT_INFO_RESP);
export const initUpdateSvcRptInfoResp = createAction(INIT_UPDATE_SVC_RPT_INFO_RESP);
export const initSvcRptHistInitDataResp = createAction(INIT_GET_SVC_RPT_HIST_INIT_DATA_RESP);
export const initSvcRptHistListResp = createAction(INIT_GET_SVC_RPT_HIST_LIST_RESP);
export const initCancelSvcRptInfoResp = createAction(INIT_CANCEL_SVC_RPT_INFO_RESP);

// 1. 고객정보 조회
export const getUserInfo = createAction(GET_USER_INFO, (userInfo) => userInfo);
export const getCorpInfo = createAction(GET_CORP_INFO, (userInfo) => userInfo);
export const updateUserInfo = createAction(UPDATE_USER_INFO, (userInfo) => userInfo);
export const updateUserPwd = createAction(UPDATE_USER_PWD, (userInfo) => userInfo);
export const deleteUserInfo = createAction(DELETE_USER_INFO, (userInfo) => userInfo);
export const updateCorpInfo = createAction(UPDATE_CORP_INFO, (userInfo) => userInfo);
export const deleteCorpInfo = createAction(DELETE_CORP_INFO, (userInfo) => userInfo);

export const getSvcRptInfo = createAction(GET_SVC_RPT_INFO, (userInfo) => userInfo);

export const updateSvcRptInfo = createAction(UPDATE_SVC_RPT_INFO, (userInfo) => userInfo);
export const getSvcRptHistInitData = createAction(GET_SVC_RPT_HIST_INIT_DATA, (userInfo) => userInfo);
export const getSvcRptHistList = createAction(GET_SVC_RPT_HIST_LIST, (userInfo) => userInfo);
export const cancelSvcRptInfo = createAction(CANCEL_SVC_RPT_INFO, (userInfo) => userInfo);

const getUserInfoSaga = createRequestSaga(GET_USER_INFO, apiUsr.getUserInfo);
const getCorpInfoSaga = createRequestSaga(GET_CORP_INFO, apiUsr.getCorpInfo);
const updateUserInfoSaga = createRequestSaga(UPDATE_USER_INFO, apiUsr.updateUserInfo);
const updateUserPwdSaga = createRequestSaga(UPDATE_USER_PWD, apiUsr.updateUserPwd);
const deleteUserInfoSaga = createRequestSaga(DELETE_USER_INFO, apiUsr.deleteUserInfo);
const updateCorpInfoSaga = createRequestSaga(UPDATE_CORP_INFO, apiUsr.updateCorpInfo);
const deleteCorpInfoSaga = createRequestSaga(DELETE_CORP_INFO, apiUsr.deleteCorpInfo);

const getSvcRptInfoSaga = createRequestSaga(GET_SVC_RPT_INFO, apiUsr.getSvcRptInfo);
const updateSvcRptInfoSaga = createRequestSaga(UPDATE_SVC_RPT_INFO, apiUsr.updateSvcRptInfo);
const getSvcRptHistInitDataSaga = createRequestSaga(GET_SVC_RPT_HIST_INIT_DATA, apiUsr.getSvcRptHistInitData);
const getSvcRptHistListSaga = createRequestSaga(GET_SVC_RPT_HIST_LIST, apiUsr.getSvcRptHistList);
const cancelSvcRptInfoSaga = createRequestSaga(CANCEL_SVC_RPT_INFO, apiUsr.cancelSvcRptInfo);

/*********************************************************************************** */

// apiUserSaga
export function* apiUserSaga() {
  //서비스가입
  yield takeLatest(GET_INIT_DATA, getInitDataSaga);
  yield takeLatest(GET_BANK_ACCOUNT_LIST, getBankAccountListSaga);
  yield takeLatest(GET_CHECK_CUSTCD, getCheckCustCdSaga);
  yield takeLatest(GET_DUP_CHECK_USERID, getDupCheckUserIdSaga);
  yield takeLatest(PUT_JOIN_USERID, putJoinUserIdSaga);
  yield takeLatest(PUT_SEND_SMS, putSendSMSSaga);
  yield takeLatest(GET_CHECK_NOCERT, getCheckNoCertSaga);
  yield takeLatest(GET_POLICY, getPolicySaga);
  yield takeLatest(GET_COMPL_USER_INFO, getComplUserInfoSaga);
  yield takeLatest(SEND_CONFIRM_MSG, sendConfirmMsgSaga);
  yield takeLatest(PUT_CONFIRM_CHK, putConfirmChkSaga);

  //로그인
  yield takeLatest(SET_LOGIN, setLoginSaga);
  yield takeLatest(SET_LOGOUT, setLogoutSaga);
  //새로운 정책조회
  yield takeLatest(GET_NEW_POLICY, getNewPolicySaga);
  //새로운 정책동의
  yield takeLatest(SET_NEW_POLICY, setNewPolicySaga);
  //비밀번호찾기
  yield takeLatest(SEND_TEMP_PWD, sendTempPwdSaga);
  //새비밀번호설정
  yield takeLatest(SET_NEW_PWD, setNewPwdSaga);
  //새비밀번호설정(변경주기)
  yield takeLatest(SET_NEW_PWD_BY_PERIOD, setNewPwdbyPeriodSaga);
  //비밀번호 변경주기 연장
  yield takeLatest(SET_DELAY_PWD_DT, setDelayPwdDtSaga);
  //중복로그인 로그 저장
  yield takeLatest(SET_LOGIN_LOG, setLoginLogSaga);
  //마이페이지 고객조회
  yield takeLatest(GET_USER_INFO, getUserInfoSaga);
  //고객정보수정
  yield takeLatest(UPDATE_USER_INFO, updateUserInfoSaga);
  //비밀번호변경
  yield takeLatest(UPDATE_USER_PWD, updateUserPwdSaga);
  //고객정보삭제
  yield takeLatest(DELETE_USER_INFO, deleteUserInfoSaga);
  //사업장조회
  yield takeLatest(GET_CORP_INFO, getCorpInfoSaga);
  //사업자정보수정
  yield takeLatest(UPDATE_CORP_INFO, updateCorpInfoSaga);
  //서비스해지
  yield takeLatest(DELETE_CORP_INFO, deleteCorpInfoSaga);

  // 서비스요금제 조회
  yield takeLatest(GET_SVC_RPT_INFO, getSvcRptInfoSaga);
  //서비스요금제 수정
  yield takeLatest(UPDATE_SVC_RPT_INFO, updateSvcRptInfoSaga);
  //서비스요금제 초기데이터
  yield takeLatest(GET_SVC_RPT_HIST_INIT_DATA, getSvcRptHistInitDataSaga);
  //서비스요금제 이력조회
  yield takeLatest(GET_SVC_RPT_HIST_LIST, getSvcRptHistListSaga);
  //서비스요금제 취소
  yield takeLatest(CANCEL_SVC_RPT_INFO, cancelSvcRptInfoSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getInitDataResp: null,
  getBankAccountListResp: null,
  getCheckCustCdResp: null,
  getDupCheckUserIdResp: null,
  putJoinUserIdResp: null,
  putSendSMSResp: null,
  getCheckNoCertResp: null,
  getPolicyResp: null,
  getComplUserInfoResp: null,
  sendConfirmMsgResp: null,
  putConfirmChkResp: null,
  setLoginResp: null,
  setLogoutResp: null,
  getNewPolicyResp: null,
  setNewPolicyResp: null,
  sendTempPwdResp: null,
  setNewPwdResp: null,
  setNewPwdbyPeriodResp: null,
  setDelayPwdDtResp: null,
  setLoginLogResp: null,
  getUserInfoResp: null,
  getCorpInfoResp: null,
  updateUserInfoResp: null,
  updateUserPwdResp: null,
  deleteUserInfoResp: null,
  updateCorpInfoResp: null,
  deleteCorpInfoResp: null,
  getSvcRptInfoResp: null,
  updateSvcRptInfoResp: null,
  getSvcRptHistInitDataResp: null,
  getSvcRptHistListResp: null,
  cancelSvcRptInfoResp: null,
};

const apiUserResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_USER_RESP]: (state, action) => ({
      getInitDataResp: null,
      getBankAccountListResp: null,
      getCheckCustCdResp: null,
      getDupCheckUserIdResp: null,
      putJoinUserIdResp: null,
      putSendSMSResp: null,
      getCheckNoCertResp: null,
      getPolicyResp: null,
      getComplUserInfoResp: null,
      sendConfirmMsgResp: null,
      putConfirmChkResp: null,
      setLoginResp: null,
      setLogoutResp: null,
      getNewPolicyResp: null,
      setNewPolicyResp: null,
      sendTempPwdResp: null,
      setNewPwdResp: null,
      setNewPwdbyPeriodResp: null,
      setDelayPwdDtResp: null,
      setLoginLogResp: null,
      getUserInfoResp: null,
      getCorpInfoResp: null,
      updateUserInfoResp: null,
      updateUserPwdResp: null,
      deleteUserInfoResp: null,
      updateCorpInfoResp: null,
      deleteCorpInfoResp: null,
      getSvcRptInfoResp: null,
      updateSvcRptInfoResp: null,
      getSvcRptHistInitDataResp: null,
      getSvcRptHistListResp: null,
      cancelSvcRptInfoResp: null,
    }),
    [INIT_INIT_DATA_RESP]: (state, action) => ({
      ...state,
      getInitDataResp: null,
    }),
    [INIT_BANK_ACCOUNT_LIST_RESP]: (state, action) => ({
      ...state,
      getBankAccountListResp: null,
    }),
    [INIT_CHECK_CUSTCD_RESP]: (state, action) => ({
      ...state,
      getCheckCustCdResp: null,
    }),
    [INIT_DUP_CHECK_USERID_RESP]: (state, action) => ({
      ...state,
      getDupCheckUserIdResp: null,
    }),
    [INIT_JOIN_USERID_RESP]: (state, action) => ({
      ...state,
      putJoinUserIdResp: null,
    }),
    [INIT_SEND_SMS_RESP]: (state, action) => ({
      ...state,
      putSendSMSResp: null,
    }),
    [INIT_CHECK_NOCERT_RESP]: (state, action) => ({
      ...state,
      getCheckNoCertResp: null,
    }),
    [INIT_POLICY_RESP]: (state, action) => ({
      ...state,
      getPolicyResp: null,
    }),
    [INIT_COMPL_USER_INFO_RESP]: (state, action) => ({
      ...state,
      getComplUserInfoResp: null,
    }),
    [INIT_SEND_CONFIRM_MSG_RESP]: (state, action) => ({
      ...state,
      sendConfirmMsgResp: null,
    }),
    [INIT_PUT_CONFIRM_CHK_RESP]: (state, action) => ({
      ...state,
      putConfirmChkResp: null,
    }),

    [INIT_LOGIN_RESP]: (state, action) => ({
      ...state,
      setLoginResp: null,
    }),
    [INIT_LOGOUT_RESP]: (state, action) => ({
      ...state,
      setLogoutResp: null,
    }),

    [INIT_GET_NEW_POLICY_RESP]: (state, action) => ({
      ...state,
      getNewPolicyResp: null,
    }),
    [INIT_SET_NEW_POLICY_RESP]: (state, action) => ({
      ...state,
      setNewPolicyResp: null,
    }),
    [INIT_SEND_TEMP_PWD_RESP]: (state, action) => ({
      ...state,
      sendTempPwdResp: null,
    }),
    [INIT_SET_NEW_PWD_RESP]: (state, action) => ({
      ...state,
      setNewPwdResp: null,
    }),
    [INIT_SET_NEW_PWD_BY_PERIOD_RESP]: (state, action) => ({
      ...state,
      setNewPwdbyPeriodResp: null,
    }),
    [INIT_DELAY_PWD_DT_RESP]: (state, action) => ({
      ...state,
      setDelayPwdDtResp: null,
    }),
    [INIT_LOGIN_LOG_RESP]: (state, action) => ({
      ...state,
      setLoginLogResp: null,
    }),

    [INIT_GET_USER_INFO_RESP]: (state, action) => ({
      ...state,
      getUserInfoResp: null,
    }),
    [INIT_GET_CORP_INFO_RESP]: (state, action) => ({
      ...state,
      getCorpInfoResp: null,
    }),
    [INIT_UPDATE_USER_INFO_RESP]: (state, action) => ({
      ...state,
      updateUserInfoResp: null,
    }),
    [INIT_UPDATE_USER_PWD_RESP]: (state, action) => ({
      ...state,
      updateUserPwdResp: null,
    }),
    [INIT_DELETE_USER_INFO_RESP]: (state, action) => ({
      ...state,
      deleteUserInfoResp: null,
    }),

    [INIT_UPDATE_CORP_INFO_RESP]: (state, action) => ({
      ...state,
      updateCorpInfoResp: null,
    }),
    [INIT_DELETE_CORP_INFO_RESP]: (state, action) => ({
      ...state,
      deleteCorpInfoResp: null,
    }),

    [INIT_GET_SVC_RPT_INFO_RESP]: (state, action) => ({
      ...state,
      getSvcRptInfoResp: null,
    }),
    [INIT_UPDATE_SVC_RPT_INFO_RESP]: (state, action) => ({
      ...state,
      updateSvcRptInfoResp: null,
    }),
    [INIT_GET_SVC_RPT_HIST_INIT_DATA_RESP]: (state, action) => ({
      ...state,
      getSvcRptHistInitDataResp: null,
    }),
    [INIT_GET_SVC_RPT_HIST_LIST_RESP]: (state, action) => ({
      ...state,
      getSvcRptHistListResp: null,
    }),
    [INIT_CANCEL_SVC_RPT_INFO_RESP]: (state, action) => ({
      ...state,
      cancelSvcRptInfoResp: null,
    }),

    // 1. 서비스신청 납부방법 조회
    [GET_INIT_DATA_SUCCESS]: (state, action) => ({
      ...state,
      getInitDataResp: action.payload,
    }),
    [GET_INIT_DATA_FAILURE]: (state, action) => ({
      ...state,
      getInitDataResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 2. 서비스신청 은행계좌 조회
    [GET_BANK_ACCOUNT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getBankAccountListResp: action.payload,
    }),
    [GET_BANK_ACCOUNT_LIST_FAILURE]: (state, action) => ({
      ...state,
      getBankAccountListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 3. 서비스신청 고객코드 체크
    [GET_CHECK_CUSTCD_SUCCESS]: (state, action) => ({
      ...state,
      getCheckCustCdResp: action.payload,
    }),
    [GET_CHECK_CUSTCD_FAILURE]: (state, action) => ({
      ...state,
      getCheckCustCdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 4. 서비스신청 고객코드 체크
    [GET_DUP_CHECK_USERID_SUCCESS]: (state, action) => ({
      ...state,
      getDupCheckUserIdResp: action.payload,
    }),
    [GET_DUP_CHECK_USERID_FAILURE]: (state, action) => ({
      ...state,
      getDupCheckUserIdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 5. 서비스신청 회원가입
    [PUT_JOIN_USERID_SUCCESS]: (state, action) => ({
      ...state,
      putJoinUserIdResp: action.payload,
    }),
    [PUT_JOIN_USERID_FAILURE]: (state, action) => ({
      ...state,
      putJoinUserIdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 6. SMS발송
    [PUT_SEND_SMS_SUCCESS]: (state, action) => ({
      ...state,
      putSendSMSResp: action.payload,
    }),
    [PUT_SEND_SMS_FAILURE]: (state, action) => ({
      ...state,
      putSendSMSResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 7. 서비스신청 회원가입
    [GET_CHECK_NOCERT_SUCCESS]: (state, action) => ({
      ...state,
      getCheckNoCertResp: action.payload,
    }),
    [GET_CHECK_NOCERT_FAILURE]: (state, action) => ({
      ...state,
      getCheckNoCertResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 8. 상담 신청 페이지 정책 조회
    [GET_POLICY_SUCCESS]: (state, action) => ({
      ...state,
      getPolicyResp: action.payload,
    }),
    [GET_POLICY_FAILURE]: (state, action) => ({
      ...state,
      getPolicyResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 9. 상담 신청 페이지 정책 조회
    [GET_COMPL_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      getComplUserInfoResp: action.payload,
    }),
    [GET_COMPL_USER_INFO_FAILURE]: (state, action) => ({
      ...state,
      getComplUserInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [SEND_CONFIRM_MSG_SUCCESS]: (state, action) => ({
      ...state,
      sendConfirmMsgResp: action.payload,
    }),
    [SEND_CONFIRM_MSG_FAILURE]: (state, action) => ({
      ...state,
      sendConfirmMsgResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 2차 인증 메세지 체크
    [PUT_CONFIRM_CHK_SUCCESS]: (state, action) => ({
      ...state,
      putConfirmChkResp: action.payload,
    }),
    [PUT_CONFIRM_CHK_FAILURE]: (state, action) => ({
      ...state,
      putConfirmChkResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 10. 로그인
    [SET_LOGIN_SUCCESS]: (state, action) => ({
      ...state,
      setLoginResp: action.payload,
    }),
    [SET_LOGIN_FAILURE]: (state, action) => ({
      ...state,
      setLoginResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [SET_LOGOUT_SUCCESS]: (state, action) => ({
      ...state,
      setLogoutResp: action.payload,
    }),
    [SET_LOGOUT_FAILURE]: (state, action) => ({
      ...state,
      setLogoutResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 새로운정책 조회
    [GET_NEW_POLICY_SUCCESS]: (state, action) => ({
      ...state,
      getNewPolicyResp: action.payload,
    }),
    [GET_NEW_POLICY_FAILURE]: (state, action) => ({
      ...state,
      getNewPolicyResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 새로운정책 동의
    [SET_NEW_POLICY_SUCCESS]: (state, action) => ({
      ...state,
      setNewPolicyResp: action.payload,
    }),
    [SET_NEW_POLICY_FAILURE]: (state, action) => ({
      ...state,
      setNewPolicyResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 비밀번호찾기
    [SEND_TEMP_PWD_SUCCESS]: (state, action) => ({
      ...state,
      sendTempPwdResp: action.payload,
    }),
    [SEND_TEMP_PWD_FAILURE]: (state, action) => ({
      ...state,
      sendTempPwdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 새비밀번호설정
    [SET_NEW_PWD_SUCCESS]: (state, action) => ({
      ...state,
      setNewPwdResp: action.payload,
    }),
    [SET_NEW_PWD_FAILURE]: (state, action) => ({
      ...state,
      setNewPwdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 새비밀번호설정(변경주기)
    [SET_NEW_PWD_BY_PERIOD_SUCCESS]: (state, action) => ({
      ...state,
      setNewPwdbyPeriodResp: action.payload,
    }),
    [SET_NEW_PWD_BY_PERIOD_FAILURE]: (state, action) => ({
      ...state,
      setNewPwdbyPeriodResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 비밀번호변경주기 연장
    [SET_DELAY_PWD_DT_SUCCESS]: (state, action) => ({
      ...state,
      setDelayPwdDtResp: action.payload,
    }),
    [SET_DELAY_PWD_DT_FAILURE]: (state, action) => ({
      ...state,
      setDelayPwdDtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [SET_LOGIN_LOG_SUCCESS]: (state, action) => ({
      ...state,
      setLoginLogResp: action.payload,
    }),
    [SET_LOGIN_LOG_FAILURE]: (state, action) => ({
      ...state,
      setLoginLogResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //마이페이지 고객조회
    [GET_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      getUserInfoResp: action.payload,
    }),
    [GET_USER_INFO_FAILURE]: (state, action) => ({
      ...state,
      getUserInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //개인정보 수정
    [UPDATE_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      updateUserInfoResp: action.payload,
    }),
    [UPDATE_USER_INFO_FAILURE]: (state, action) => ({
      ...state,
      updateUserInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //비밀번호변경
    [UPDATE_USER_PWD_SUCCESS]: (state, action) => ({
      ...state,
      updateUserPwdResp: action.payload,
    }),
    [UPDATE_USER_PWD_FAILURE]: (state, action) => ({
      ...state,
      updateUserPwdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //개인정보 삭제
    [DELETE_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      deleteUserInfoResp: action.payload,
    }),
    [DELETE_USER_INFO_FAILURE]: (state, action) => ({
      ...state,
      deleteUserInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //마이페이지 사업자정보조회
    [GET_CORP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      getCorpInfoResp: action.payload,
    }),
    [GET_CORP_INFO_FAILURE]: (state, action) => ({
      ...state,
      getCorpInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    //사업자정보 수정
    [UPDATE_CORP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      updateCorpInfoResp: action.payload,
    }),
    [UPDATE_CORP_INFO_FAILURE]: (state, action) => ({
      ...state,
      updateCorpInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //서비스 해지
    [DELETE_CORP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      deleteCorpInfoResp: action.payload,
    }),
    [DELETE_CORP_INFO_FAILURE]: (state, action) => ({
      ...state,
      deleteCorpInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    //마이페이지 서비스요금제 조회
    [GET_SVC_RPT_INFO_SUCCESS]: (state, action) => ({
      ...state,
      getSvcRptInfoResp: action.payload,
    }),
    [GET_SVC_RPT_INFO_FAILURE]: (state, action) => ({
      ...state,
      getSvcRptInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [UPDATE_SVC_RPT_INFO_SUCCESS]: (state, action) => ({
      ...state,
      updateSvcRptInfoResp: action.payload,
    }),
    [UPDATE_SVC_RPT_INFO_FAILURE]: (state, action) => ({
      ...state,
      updateSvcRptInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    [GET_SVC_RPT_HIST_INIT_DATA_SUCCESS]: (state, action) => ({
      ...state,
      getSvcRptHistInitDataResp: action.payload,
    }),
    [GET_SVC_RPT_HIST_INIT_DATA_FAILURE]: (state, action) => ({
      ...state,
      getSvcRptHistInitDataResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    [GET_SVC_RPT_HIST_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getSvcRptHistListResp: action.payload,
    }),
    [GET_SVC_RPT_HIST_LIST_FAILURE]: (state, action) => ({
      ...state,
      getSvcRptHistListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    [CANCEL_SVC_RPT_INFO_SUCCESS]: (state, action) => ({
      ...state,
      cancelSvcRptInfoResp: action.payload,
    }),
    [CANCEL_SVC_RPT_INFO_FAILURE]: (state, action) => ({
      ...state,
      cancelSvcRptInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiUserResp;
